import {Logo} from '@repo/ui/logo';
import {FRONTEND_URL} from 'config';

export function TheLoopExperienceSubmissionHeader() {
  return (
    <header className='sticky top-0 z-50 bg-white border-b border-gray-100'>
      <div className='max-w-(--iq-content-width) mx-auto px-5 h-(--iq-header-height) flex items-center justify-between'>
        <div className='-mt-2'>
          <Logo href={FRONTEND_URL} />
        </div>
        <div className='flex items-end gap-2'>
          <span className='text-xs text-gray-400 font-normal'>submitting experience for</span>
          <span
            style={{
              fontFamily: 'var(--font-loop-logo), cursive',
              fontSize: 28,
              color: '#1a1714',
              fontWeight: 400,
              letterSpacing: 0.5,
              lineHeight: 1,
            }}>
            The Loop
          </span>
        </div>
      </div>
    </header>
  );
}
